// extracted by mini-css-extract-plugin
module.exports = {"inputMask":"InputMaskField_inputMask__3KsZP","empty":"InputMaskField_empty__It-_N"};